import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ExpensesList } from './ExpensesList';
import { useState } from 'react';
import PopUp from './PopUp';
import Header from "./Header";
import Loader from "./Loader";
import "./css/AdminBookings.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, ExpenseGetAPIEndpoint } from '../constant';
import { useEffect } from 'react';
import { format } from "date-fns";
// import { API_BASE_URL, UsersGetAPIEndPoint } from '../constant';


// export const expensesList = ExpensesList;




export default function OwnerList() {
const token = sessionStorage.getItem("JWTtoken");

 const [expenses, setexpenses] = useState([]);
const [expensestatus, setexpensestatus] = useState("All");
const [loading, setLoading] = useState(false);
const [userData, setUserData] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [error, setError] = useState("");
const recordsPerPage = 8; 
const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;
const currentRecords = userData.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(userData.length / recordsPerPage);
const setResidentID = sessionStorage.getItem("residentId");
const userType = sessionStorage.getItem("userType");
const [showPopUp, setShowPopUp] = useState(false);
 
 useEffect(() => {
    GetAll("", "");
  }, []);


  /*
 const fetchexpenses = async () => {
      try {
        const apiURL = API_BASE_URL + ExpenseGetAPIEndpoint;
        const response = await fetch(apiURL);
        const res = await response.json();

        if (res.status) {          
          setUserData(res.data);
          //alert(userData.length);
        } else {
          setError(res.message || "Failed to fetch notices");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };
*/

  const GetAll = async(status, statusType) => {
    
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;

  const currentRecords = userData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(userData.length / recordsPerPage);

    setLoading(true);    
    setCurrentPage(1);  



    try {
        const apiURL = API_BASE_URL + ExpenseGetAPIEndpoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const res = await response.json();

        if (res.status) {
          if(status === "" && statusType === "")
          {
             //alert(status);
            setexpensestatus("All");
            //alert(userData.length);
            setUserData(res.data);
          }
          else if(status !== "" && statusType === "payment_mode")
          {
            setexpensestatus(status);
            const loggedInUserData = res.data.filter(expense => expense.payment_mode === status);
            setUserData(loggedInUserData);
          }
          else if( status !== "" && statusType === "expense_status")
          {
           setexpensestatus(status);
            const loggedInUserData = res.data.filter(expense => expense.expense_status === status);
            setUserData(loggedInUserData);
          }
          //setexpenses(res.data);
        } else {
          setError(res.message || "Failed to fetch expenses");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
  }


  const navigate = useNavigate();

  const OpenAddExpenseForm = () => {
    navigate("/Expenses/AddExpense?mode=add");
  };


const handleEdit = (row) => {
    
    //setForm({ name: r.name, email: r.email, phone: r.phone, apartment: r.apartment, owner: String(r.owner), sold: String(r.sold) });
    
    //setEditingId(r.id);
    alert("Edit Record : " + row.expense_id);
    localStorage.setItem("expenseData", JSON.stringify(row));
    console.log("Edit Record : " + row);
    console.log("Edit Record : " + JSON.stringify(row));
     navigate("/Expenses/EditExpense?mode=edit&expense_id=" + row.expense_id);
   
  };

  const handleDelete = (row) => {
    
    //setForm({ name: r.name, email: r.email, phone: r.phone, apartment: r.apartment, owner: String(r.owner), sold: String(r.sold) });
    
    //setEditingId(r.id);
    alert("Delete Record : " + row.expense_id);
  };

  
    return (<>
    <Header/>  
    {





    <div className="admin-bookings">        
      <h2 style={{ textTransform: 'capitalize' }}>{expensestatus} expenses  
              <div className="table-container">
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("UPI", "payment_mode")}
                >
                  UPI
                </button>
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Bank", "payment_mode")}
                >
                  Bank 
                </button>
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Cash", "payment_mode")}
                >
                  Cash
                </button>
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Cheque", "payment_mode")}
                >
                  Cheque
                </button>

                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Refunded", "expense_status")}
                >
                  Refunded
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Failed", "expense_status"  )}
                >
                  Failed
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Pending", "expense_status")}
                >
                  Pending
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("Paid", "expense_status")}
                >
                  Paid
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("", "")}
                >
                  All
                </button> 

                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                 onClick={OpenAddExpenseForm}
                >
                  Add Expense
                </button> 
              </div>
                
                
      </h2>
        {loading && <Loader />}
         <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>expense_date</th>
            <th>expense_title</th>
            <th>category</th>
            <th>total_amount</th>
            <th>payment_mode</th>
            <th>expense_status</th>
            <th>paid_by</th>
            <th>vendor_name</th>
            <th>invoice_no</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>          
          {
            currentRecords.length > 0 ? (
            currentRecords.map((row) => (
            <tr key={row.expense_id} style={{ borderBottom: "1px solid #dee2e6"}}>
              <td>{row.expense_date}</td>
              <td>{row.expense_title    }</td>
              <td>{row.category}</td>
              <td>{row.total_amount} ({row.gst_amount} + {row.amount})</td>
              <td>{row.payment_mode}</td>
              <td>{row.expense_status}</td>
              <td>{row.PaidByName}</td>
              <td>{row.vendor_name}</td>
              <td>{row.invoice_no}</td>              
              <td className="actions-cell">
                { <button                
                  className="btn-approve"
                  onClick={() => handleEdit(row)}
                style={{ marginLeft: "6px" }}
                >
                  Edit 
                </button>}
                 {<button                
                  className="btn-reject"
                   onClick={() => handleDelete(row)}
                style={{ marginLeft: "6px" }}
                >
                  Delete
                </button>}
              </td>
            </tr>
          ))
          ) : (
            <tr>
              <td colSpan="6" align="center">No records found</td>
            </tr>
          )
          }
        </tbody>
      </table>
      </div>
<div style={{ marginTop: "10px" }}>
    <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}> Prev 
  </button>

  {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      style={{
        fontWeight: currentPage === i + 1 ? "bold" : "normal",
        margin: "0 5px"
      }}
    >
      {i + 1}
    </button>
  ))}

  <button
    onClick={() =>
      setCurrentPage(prev => Math.min(prev + 1, totalPages))
    }
    disabled={currentPage === totalPages}
  >
    Next
  </button> { indexOfFirst + 1} to {userData.length < indexOfLast ? userData.length : indexOfLast} of Total Record {userData.length} 
</div>
    </div>


    }
    
    
    <PopUp showPopUp={showPopUp} closePopUp={()=>setShowPopUp(false)}>
          <h2> pop up opened</h2>  
    </PopUp>
    
    </>

    
  );
  };